var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
var base = 8;
export function getShadow(strength, placement) {
    if (strength === void 0) { strength = 0; }
    if (placement === void 0) { placement = 'center'; }
    var blur = base * strength;
    var distance = blur / 4;
    var opacity = (blur * 2) / 100;
    var spread = -1 * (distance / 2);
    var xDelta = placement.match('(left|right)') ? distance : 0;
    var yDelta = placement.match('(top|bottom)') ? distance : 0;
    var xMagnitude = placement.match('left') ? -1 : 1;
    var yMagnitude = placement.match('top') ? -1 : 1;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    box-shadow: ", ";\n  "], ["\n    box-shadow: ", ";\n  "])), xMagnitude * xDelta + "px " + yMagnitude * yDelta + "px " + blur + "px " + spread + "px hsla(200, 10%, 15%, " + opacity + ")");
}
var templateObject_1;
//# sourceMappingURL=shadows.js.map